export default __webpack_public_path__ + "static/media/online.c0b0be08.svg";